export const tickColor    = '#6B7280';
export const gridColor   = 'rgba(0,0,0,0.06)';
export const baseFont    = "'Inter', 'Helvetica Neue', Arial, sans-serif";

export const FALLBACK_COLORS = [
    'rgba(99,  102, 241, 0.85)', 'rgba(234, 179,   8, 0.85)',
    'rgba(239,  68,  68, 0.85)', 'rgba(34,  197,  94, 0.85)',
    'rgba(168,  85, 247, 0.85)', 'rgba(59,  130, 246, 0.85)',
];

export const AGENT_COLORS = [
    'rgba(99,  102, 241, 0.85)', 'rgba(59,  130, 246, 0.85)',
    'rgba(168,  85, 247, 0.85)', 'rgba(34,  197,  94, 0.85)',
    'rgba(245, 158,  11, 0.85)', 'rgba(239,  68,  68, 0.85)',
    'rgba(20,  184, 166, 0.85)', 'rgba(249, 115,  22, 0.85)',
];

export const STATUS_CONFIG = [
    { key: 'open',    label: 'Open',    color: 'rgba(59,  130, 246, 0.85)', hover: 'rgba(59,  130, 246, 1)' },
    { key: 'closed',  label: 'Closed',  color: 'rgba(34,  197,  94, 0.85)', hover: 'rgba(34,  197,  94, 1)' },
    { key: 'pending', label: 'Pending', color: 'rgba(234, 179,   8, 0.85)', hover: 'rgba(234, 179,   8, 1)' },
    { key: 'active',  label: 'Active',  color: 'rgba(168,  85, 247, 0.85)', hover: 'rgba(168,  85, 247, 1)' },
];
